module.exports = React.addons.TransitionGroup;


//////////////////
// WEBPACK FOOTER
// external "React.addons.TransitionGroup"
// module id = 138
// module chunks = 0